export enum EnvironmentStatus {
  Creating = 'CREATING',
  Running = 'RUNNING',
  Deleted = 'DELETED',
  Failed = 'FAILED',
}
